<template>
<div>
  <b-row>
    <b-col>
    <div class="login-register">
      <div class="login-box  back-image">
        <div class="p-5r">
          <form
            class="form-horizontal form-material"
            id="loginform"
            @submit.prevent="submit"
            @keydown="loginForm.errors.clear($event.target.name)"
          >
            <div class="form-group ">
              <input
                type="text"
                name="email"
                class="input-email"
                :placeholder="trans('auth.email')"
                v-model="loginForm.email"
              />
              <show-error :form-name="loginForm" prop-name="email"></show-error>
            </div>
            <div class="form-group d-flex">
              <input
                type="password"
                name="password"
                class="input-email"
                :placeholder="trans('auth.password')"
                v-model="loginForm.password"
              />
              <show-error
                :form-name="loginForm"
                prop-name="password"
              ></show-error>
              <button
                class="btn btn-info btn_reg text-uppercase waves-effect waves-light"
                type="submit"
              >
                {{ trans('auth.sign_in') }}
              </button>
            </div>
            <div
              class="g-recaptcha"
              v-if="getConfig('recaptcha') && getConfig('login_recaptcha')"
              :data-sitekey="getConfig('recaptcha_key')"
            ></div>
            <div class="form-group m-b-0">
              <div class="col-sm-12">
                <p>
                  {{ trans('auth.forgot_your_password?') }}
                  <router-link
                    to="/password"
                    class="text-info m-l-5 color_link"
                  >
                    <b>{{ trans('auth.reset_here!') }}</b>
                  </router-link>
                </p>
                <p>
                  {{ trans('auth.create_account?') }}
                  <router-link
                    to="/register"
                    class="text-info m-l-5 color_link"
                  >
                    <b>{{ trans('auth.sign_up') }}</b>
                  </router-link>
                </p>
              </div>
            </div>
            <div class="row" v-if="getConfig('social_login')">
              <div class="col-12 col-sm-12 m-t-10 text-center">
                <div class="social" v-if="getConfig(provider + '_login')">
                  <a
                    v-for="provider in social_login_providers"
                    :key="provider"
                    :href="`/auth/social/${provider}`"
                    :class="['btn', 'btn-' + provider, 'm-r-5', 'no-hover']"
                    v-tooltip="trans('auth.login_with', { type: provider })"
                  >
                    <i :class="['fab', 'fa-' + provider]"></i>
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
        <guest-footer></guest-footer>
      </div>
    </div>
    </b-col>
  </b-row>
</div>
</template>

<script>
import guestFooter from '../../layouts/guest-footer.vue';

export default {
  data() {
    return {
      loginForm: new Form({
        email: '',
        password: ''
      }),
      social_login_providers: []
    };
  },
  components: {
    guestFooter
  },
  mounted() {
    if (helper.getConfig('social_login'))
      axios
        .get('/api/configuration/variable?type=social_login')
        .then(response => response.data)
        .then(response => {
          this.social_login_providers = response.social_login_providers;
        })
        .catch(error => {
          helper.showDataErrorMsg(error);
        });
  },
  methods: {
    submit() {
      this.loginForm
        .post('/login')
        .then(response => {
          localStorage.setItem('auth_token', response.token);
          axios.defaults.headers.common['Authorization'] =
            'Bearer ' + localStorage.getItem('auth_token');
          this.$store.dispatch('auth/setAuthStatus');
          this.$store.dispatch('auth/setLastActivity');
          toastr.success(response.message);

          if (
            helper.getConfig('two_factor_security') &&
            response.two_factor_code
          ) {
            this.$store.dispatch(
              'auth/setTwoFactorCode',
              response.two_factor_code
            );
            this.$router.push('/auth/security');
          } else {
            var redirectRoute = this.$store.state.auth.previousPage || {
              path: '/'
            };
            if (response.reload) {
              redirectRoute.query = 1;
            }
            this.$store.dispatch('auth/resetTwoFactorCode');
            this.$router.push(redirectRoute);
            this.$store.commit('auth/setPreviousPage', null);
          }
        })
        .catch(error => {
          helper.showErrorMsg(error);
        });
    },
    loginAsAdmin() {
      this.loginForm.email = 'john.doe@example.com';
      this.loginForm.password = 'password';
      this.submit();
    },
    loginAsUser() {
      this.loginForm.email = 'marry.jen@example.com';
      this.loginForm.password = 'password';
      this.submit();
    },
    getConfig(config) {
      return helper.getConfig(config);
    }
  }
};
</script>
<style scoped>
.back-image {
  background-image: url(../../images/doctor.svg);
  background-size: 40%;
  background-position: bottom right;
  background-repeat: no-repeat;
}
.input-email {
  width: 40%;
  border-radius: 50px !important;
  border-color: transparent;
  background: linear-gradient(to left, #d4cbf5 0%, #e5c4f6 100%) !important;
  padding: 0.375rem 0.75rem;
}
.input-email::placeholder {
  color: white;
}
.input-email:focus {
  border-radius: 50px;
  outline: none;
}
.color_link {
  color: #9a30de !important;
  text-decoration: none;
}
.color_link:hover {
  color: #8d59e2 !important;
}
.color_link:focus {
  outline: none !important;
}
.btn_reg {
  position: absolute;
  right: 56.5%;
  border-radius: 50px !important;
  background: #9a30de;
  border-color: transparent;
  padding: 0.5rem 3rem;
}
.btn_reg:focus {
  border-color: transparent;
  background-color: #8d59e2 !important;
}
.btn_reg:hover {
  border-color: transparent;
  background-color: #8d59e2 !important;
}
.p-5r {
  padding: 11rem 5rem;
}
.login-register {
  background-size: 40%;
  background-position: bottom right;
  background-repeat: no-repeat;
  min-height: 100vh;
}
  .footer {
    width: 100%;
    left: 0px;
    right: 0px;
  }
  .social {
    display: block;
    margin-bottom: 30px;
  }
#recoverform {
  display: none;
}
.login-sidebar {
  padding: 0px;
  margin-top: 0px;
}
.login-box{
  min-height: 100vh;
}
.row{
  margin: 0 !important;
}
.col{
  padding: 0 !important;
}

@media (max-width: 425px){
  .back-image{
    background-size: 60%;
  }
  .p-5r{
    padding: 11rem 0rem;
  }
  .input-email{
    width: 100%
  }
  .btn_reg{
    right: 0;
  }
}
@media (max-width: 768px) and (max-width:424px){
  .p-5r{
    padding: 11rem 0rem;
  }
  .input-email{
    width: 100%
  }
  .btn_reg{
    right: 0;
  }
  .back-image{
    background-size: 80%;
  }
}
</style>
